import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

/**
 * Validator that checks if the string exceeds the maximum length.
 * @param maxLength The maximum length allowed for the string.
 * @returns A validator function that checks the string length.
 */
export function maxStringLength(maxLength: number): ValidatorFn {
	return (control: AbstractControl): ValidationErrors | null => {
		const value = control.value as string;

		if (!value) return null;

		if (value.length <= maxLength) {
			return null;
		}

		return { maxLength: 'Max ' + maxLength + ' characters exceeded' };
	};
}
